export enum PublicationDateToSortBy {
    PUBLICATION_DATE_DESC = "PUBLICATION_DATE_DESC",
    AWARD_DATE_DESC = "AWARD_DATE_DESC",
    DEADLINE_DATE_DESC = "DEADLINE_DATE_DESC",
    ESTIMATED_RENEWAL_DATE_ASC = "ESTIMATED_RENEWAL_DATE_ASC",
}
